import { QUESTIONS } from "../../api/Api";
import { useContext, useRef } from "react";
import { useIsVerified, UserContext } from "../../context/UserContext";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useClickOutside } from "../../Hooks/UseClickOutside";
import { useQuestionCreatorId, useQuestionId } from "../../Store/QuestionSlice";
import { authAxios } from "../../Axios/createAxios";
import { postHandleSubmit } from "../../Axios/fetchFunctions";
import { useAuth } from "../../context/AuthContext";
import { useOpenField } from "../../Store/MenuSlice";
import { useNavigate } from "react-router-dom";
import LikeAndDislike from "../LikeAndDislike";

export default function QuestionManagement({ isOpen, setIsOpen }) {
  const { userInfo } = useContext(UserContext);
  const questionId = useQuestionId();
  const userId = useQuestionCreatorId();
  const listRef = useRef(null);
  const { isAuth } = useAuth();
  const openField = useOpenField();
  const isVerified = useIsVerified();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const questionCreatorId = useQuestionCreatorId();
  useClickOutside(listRef, () => setIsOpen(false));
  console.log(userId);
  const like = () => postHandleSubmit(`/${QUESTIONS}/${questionId}/like`);
  const dislike = () => postHandleSubmit(`/${QUESTIONS}/${questionId}/dislike`);
  async function handleDeleteQuestion() {
    try {
      const res = await authAxios.delete(`/${QUESTIONS}/${questionId}`);
      return res;
    } catch (err) {
      throw err;
    }
  }
  const likeMutation = useMutation({
    mutationFn: like,
    onSuccess: (data) => {
      console.log(data);
    },
    onError: (e) => console.log(e),
  });
  const dislikeMutation = useMutation({
    mutationFn: dislike,
    onSuccess: (data) => {
      console.log(data);
    },
    onError: (e) => console.log(e),
  });

  const { mutate } = useMutation({
    mutationFn: handleDeleteQuestion,
    onSuccess: () => {
      queryClient.invalidateQueries("userQuestions");
    },
    onError: (e) => console.log(e),
  });

  const handleSub = () => {
    if (dislikeMutation?.isLoading || likeMutation?.isLoading) return false;
    if (!isAuth) {
      navigate("/login");
      return false;
    }
    if (!isVerified) {
      openField("isVerified");
      return false;
    }
    if (userInfo?.id === questionCreatorId) return;
    if (dislikeMutation?.isSuccess || likeMutation?.isSuccess) {
      setIsOpen(false);
    }
    return true;
  };
  const isSame = userInfo.id === questionCreatorId;
  return (
    <>
      {isOpen && (
        <ul ref={listRef} className={`question-box-back-drop ${!isOpen ? "hide" : ""}`}>
          <li>
            <button>report</button>
          </li>
          <li>
            <button
              className={`${isSame ? "event-none mixed-bg-c" : ""}`}
              onClick={() => handleSub() && likeMutation.mutate()}>
              To give
            </button>
          </li>
          <li>
            {userInfo.id === userId ? (
              <button onClick={() => mutate()}>delete</button>
            ) : (
              <button onClick={() => handleSub() && dislikeMutation.mutate()}>To take</button>
            )}
          </li>
          <li>
            <button onClick={() => setIsOpen(false)}>cancel</button>
          </li>
        </ul>
      )}
      <LikeAndDislike like={likeMutation} dislike={dislikeMutation} pos={"top-0"} />
    </>
  );
}
